const render = () => {
    return `
        <script type="text/javascript">
            if (window.BJ_REPORT && BJ_REPORT.tryJs) {
                BJ_REPORT.tryJs().spyAll();
            }
        </script>
    `;
};

export default render;
